import React, { useState } from 'react';
import {
  Checkbox,
  ControlLabel,
  FormGroup,
} from 'react-bootstrap';

const AbortBatch = (props) => {
  const [ checked, setChecked ] = useState(true);

  return (
    <div>
      <strong>All running data will be deleted!</strong>
      <FormGroup>
        <Checkbox
          inline
          className="mt-checkbox mt-checkbox-outline"
          name={'abortWithQueue'}
          checked={checked}
          onChange={e => {
            const value = e.target.checked;
            setChecked(value);
            props.onChange(value);
          }}
        >
          <span />
        </Checkbox>
        <ControlLabel>Clear the queue</ControlLabel>
      </FormGroup>
    </div>
  );
};

export default AbortBatch;
